import AdminTable from "../components/module/admin/AdminTable";
import AdminFilter from "../components/module/admin/AdminFilter";
import {SweetModal} from 'sweet-modal-vue'
import LpModal from '../components/module/common/LpModal.vue'
import AdminSimpleTable from '../components/module/admin/AdminSimpleTable';
import Structure from '../helper/structure-helper'
import OrderTable from "../components/module/admin/OrderTable";

export default {

  components: {
    AdminFilter,
    AdminTable,
    SweetModal,
    LpModal,
    AdminSimpleTable,
    OrderTable
  },

  created() {
    // tableData, filter_list 초기화
  },

  data() {
    return {
      tableData: [],
      filtered: {},
      filterData: [],
      filter_list: [],
      allCount: 0,
      filteredCount: 0,
      tableItems: [],
      structure_path:'',
      post_url:'',
      showcaseCheckArr: [],
    }
  },
  watch: {
    modalStatus(n) {
      if(n==='close' && this.post_url){
        this.getData(this.post_url);
      }
    }
  },
  computed: {
    path() {
      if (this.$store.getters.mode==='admin'){
        return this.$route.path.replace('/office/admin/','');
      }
      else if (this.$store.getters.mode==='partner'){
        return this.$route.path.replace('/office/partner/','');
      }
    }
  },

  methods: {
    getCheckedArr() {
      let id_list = [];
      for(let i=0; i<this.showcaseCheckArr.length; i++){
        if(this.showcaseCheckArr[i].value) {
          id_list.push(this.showcaseCheckArr[i].id);
        }
      }
      return id_list;
    },
    // 체크박스 일괄 선택
    clickCheckBox(res) {
      if(res===true) {
        this.showcaseCheckArr.forEach(item=> {
          item.value=true;
        })
      }
      else {
        this.showcaseCheckArr.forEach(item=> {
          item.value=false;
        })
      }
    },
    // structre_path : 필터 데이터, 테이블 데이터
    // post_url : axios 호출할 post url
    initializing(structure_path, post_url, query) {
      this.structure_path = structure_path;
      this.post_url = post_url;
      this.setStructure(structure_path);
      this.initFiltered(query);
      this.getData();
    },
    setStructure(structure_path) {
      // console.log('structure', structure_path)
      // structure.js 에서 경로에 맞는 데이터를 온다.
      this.filterData = Structure[structure_path+'_filter_data'];
      this.tableData = Structure[structure_path+'_table_data'];

    },
    initFiltered(query) {
      /*this.filtered.cur_page=1;
      this.filtered.page_num=1;
      this.filtered.total_page="";
      this.filtered.page_length=10;
      };*/
      this.filtered = {
        cur_page: 1,
        page_num:1,
        total_page:1,
        page_length: 10
      };
      if(query!==undefined) {
        for(let key in query) {
          if (query.hasOwnProperty(key)) {
            this.filtered[key] = query[key];
          }
        }
      }

      /*if ( this.path === 'product/reviewnew' ) {
        this.filtered.reply = 'false';
      }
      if ( this.path === 'product/inquirynew' ) {
        this.filtered.is_answered = 'true';
        this.filtered.is_checked = 'false';
      }
      if ( this.path === 'onetoone/new' ) {
        this.filtered.is_new = 'false';
        this.filtered.is_answered = 'false';
      }


      }*/

    },

    getData() {
      if(!this.post_url) return;
      let url = '';
      if(this.$route.fullPath==='/office/admin/master/notice') {
        url = this.masterBackendUrl + this.post_url;
      } else if(this.post_url.indexOf('serviceadmin')>-1) {
        url = this.post_url;
      }
      else {
        url = this.getUrl(this.post_url);
      }
      this.$axios.get(url, {
        params: this.filtered
      })
      .then(res => {
        if ( res.status === 200 ) {
          if ( res.data.data === undefined )
            this.tableItems = res.data;
          else
            this.tableItems = res.data.data;

          this.filtered.page_length = res.data.page_length;
          this.filtered.cur_page = res.data.cur_page;
          this.filtered.total_page = res.data.total_page;
          // console.log('total_page',this.filtered.total_page)
          this.allCount = res.data.total_count;
          this.filteredCount = res.data.count;

          // id번호 배열 구성후 변수에 저장
          let tableList = [];
          for (let i = 0; i < res.data.data.length; i++) {
            tableList.push({id: res.data.data[i].id, value: false});
          }
          this.showcaseCheckArr = tableList;

          // 기획전, 게시물에서 모달로 상품을 띄울 경우 선택된 상품이 있으면 체크 표시
          if(this.selectedItems && this.selectedItems.length>0) {
            this.showcaseCheckArr.forEach(item=>{
              if(this.selectedItems.includes(item.id)){
                item.value = true;
              }
            })
          }
        }
      }).catch(res => {});
    },

    selPageLength(length) {
      this.filtered.page_length = length;
      this.filtered.page_num = 1;
      this.getData();
    },

    ordering(res){
      this.filtered.ordering=res;
      this.getData();
    },

    autoHyphenPhone(str) {
      str = str.replace(/[^0-9]/g, '');
      var tmp = '';

      if (str.substr(0, 2) == '02') {
        if (str.length < 3) {
          return str;
        } else if (str.length < 6) {
          tmp += str.substr(0, 2);
          tmp += '-';
          tmp += str.substr(2);
          return tmp;
        } else if (str.length < 10) {
          tmp += str.substr(0, 2);
          tmp += '-';
          tmp += str.substr(2, 3);
          tmp += '-';
          tmp += str.substr(5);
          return tmp;
        } else {
          tmp += str.substr(0, 2);
          tmp += '-';
          tmp += str.substr(2, 4);
          tmp += '-';
          tmp += str.substr(6);
          return tmp;
        }
      }
      else {
        if (str.length < 4) {
          return str;
        } else if (str.length < 7) {
          tmp += str.substr(0, 3);
          tmp += '-';
          tmp += str.substr(3);
          return tmp;
        } else if (str.length < 11) {
          tmp += str.substr(0, 3);
          tmp += '-';
          tmp += str.substr(3, 3);
          tmp += '-';
          tmp += str.substr(6);
          return tmp;
        } else {
          tmp += str.substr(0, 3);
          tmp += '-';
          tmp += str.substr(3, 4);
          tmp += '-';
          tmp += str.substr(7);
          return tmp;
        }
      }
      return str;
    }
  }
}
